const querySelectorAsync = (selector) => {
  return new Promise((resolve, reject) => {
    // Check if the element already exists
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutations, observerInstance) => {
      const localElement = document.querySelector(selector);
      if (localElement) {
        resolve(localElement);
        observerInstance.disconnect(); // Stop observing once the element is found
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Set a timeout to reject the promise if the element is not found within a reasonable time
    setTimeout(() => {
      observer.disconnect();
      reject(
        new Error(
          `Element with selector "${selector}" not found within the timeout period.`
        )
      );
    }, 10000); // 10 seconds timeout, adjust as needed
  });
};

const clickElemOnExist = async (selector) => {
  (await querySelectorAsync(selector)).click();
};

export default clickElemOnExist;
